// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"6b38623d","403":"6b38623d"}[chunkId] + ".chunk.css";
};